module.exports = __webpack_public_path__ + "img/让河乡.c4bb2a8c.png";